import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ebeihilfe-shield-lock-svg',
  templateUrl: './shield-lock-svg.component.svg',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class ShieldLockSvgComponent {}
